module.exports = __webpack_public_path__ + "static/brand4-5725c8a35cc5107da437efb65dec4708.png";